/// <reference path="../../../../../typings/index.d.ts" />

// Todo: make as reusable directive 
module Meevo.Plugins.Egifts {
    export class MeevoHideElementOutsideClick implements angular.IDirective {
        restrict = "A";
        scope = {
            elementId: '@',
            parentClass: '@',
            closeAction: '&'
        };
        link = (scope: any, element: angular.IAugmentedJQuery) => {
            element.on('click', event => {
                const elementToHide = element.find('#' + scope.elementId);
                const parentElement = elementToHide.closest('.' + scope.parentClass);
                const isTargetInsideParent = !!angular.element(event.target).closest('.' + scope.parentClass)[0];
                if (elementToHide[0] && parentElement[0] && !isTargetInsideParent){
                    scope.closeAction();
                }
            });
        };

        constructor() {}

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoHideElementOutsideClick();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module("meevo.plugins.egifts")
        .directive("meevoHideElementOutsideClick", MeevoHideElementOutsideClick.factory());
}